import React from 'react';
import formatCurrency from '@afosto/utils/formatCurrency';
import { FormattedMessage } from 'react-intl';

export const valueFormatter = (cell, row) =>
  row?.is_percentage ? `${cell}%` : formatCurrency(cell / 100);

export const typeFormatter = cell => (
  <FormattedMessage
    id={`serviceCostForm.types.${cell}`}
    defaultMessage={cell}
    description={`Label of the service type ${cell}`}
  />
);

export const vatTypeFormatter = cell => (
  <FormattedMessage
    id={`serviceCostForm.vatTypes.${cell}`}
    defaultMessage={cell}
    description={`Label of the vat type ${cell}`}
  />
);
